<template>
  <div class="hd">
    <div class="one_menu_div">
      <ul class="one_menu_ul">
        <li
          v-for="(item, index) in integrSysMenu"
          :key="index"
          @click="oneMenuClick(item)"
          :class="[
            'one_menu_li',
            { one_menu_li_sel: item.menuCode == topMenuSelectVal },
          ]"
        >
          <i :class="['iconfont', item.icon]"></i>
          <span>{{ item.menuName }}</span>
        </li>
      </ul>
    </div>
    <div class="hd_title_div">
      <div>
        <el-image
          class="logo_img"
          :src="imgUrl"
        ></el-image>
        <!-- <el-image
          class="logo_img"
          :src="require('../../assets/images/iems/iems_logo.png')"
        ></el-image> -->
        <!--        <h1>iDEEP3100</h1>-->
        <h1>{{ sysName }}</h1>
      </div>
    </div>
    <div class="hd_right_div">
      <datetime class="datetime_css"></datetime>
      <user-select class="user_select_css"></user-select>
      <button
        class="iconfont fullscreen"
        :class="isFullscreen ? 'icon-quanping' : 'icon-quanping1'"
        @click="toggleFullScreen"
      ></button>
      <button
        class="iconfont icon-dengchu-box-r-xian logout_but"
        @click="logout"
      ></button>
    </div>
  </div>
</template>

<script>
import myApi from "../../util/my-api";
import myConst from "../../util/my-const";
import datetime from "./datetime";
import userSelect from "./user-select";
import fun from "@/util/util";
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "top-head",
  components: {
    datetime,
    userSelect,
  },
  data() {
    return {
      sysName: "",
      isFullscreen: false,
      imgUrl:require("../../assets/images/iems/iems_logo.png"), //系统图片
    };
  },
  computed: {
    ...mapState("integSysMenu", [
      "integrSysMenu",
      "topMenuSelectVal",
      "threeMenuSelectVal",
      'statList'
    ]),
    ...mapState("statMenu", ["statId", "statMenuSeVal", "statMenuList"]),
    ...mapGetters("integSysMenu", ["getIntegrSysMenu","getStationList"]),
  },
  methods: {
    ...mapMutations("integSysMenu", ["setTopMenuSelVal","setTwoMenuSelVal","setStationList","setIntegrSysMenu"]),
    ...mapMutations("statMenu", [
      "setStatId",
      "setStatMenuSelVal",
      "setStatMenuList",
      "setStatName",
      "setDevId",
      "setDevType",
    ]),

    //加载字典的系统名称
    loadDicSysName() {
      let _this = this;
      this.$axios
        .get(myApi.dictGetSysName)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.sysName = res.data.data;
          }
        })
        .catch(() => {});
    },

    //加载系统名称
    loadSysName() {
      let data = {
        infoCode: myConst.companyInfoCode.nameKey1,
      };
      this.$axios
        .post(myApi.getCompanyInfo, data)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            let obj = res.data.data;
            //创建map对象
            let myMap = new Map();
            // 遍历Vue对象的属性，并将其添加到Map对象中
            Object.entries(obj).forEach(([key, value]) => {
              myMap.set(key, value);
            });
            //判断map对象里面有没有当前key
            if (myMap.has(myConst.companyInfoCode.nameKey1)) {
              this.sysName = myMap.get(
                myConst.companyInfoCode.nameKey1
              ).infoVal;
            } else {
              //如果map对象里面没有当前的key,则加载字典里面的系统名称
              this.loadDicSysName();
            }
          } else {
            //接口请求失败加载字典里面的系统名称
            this.loadDicSysName();
          }
        })
        .catch(() => {
          this.loadDicSysName();
        });
    },

    //加载系统图片
    loadSysImg(){
      const data = {
        infoCode: myConst.companyInfoCode.nameKey3,
      };
      this.$axios
        .post(myApi.getCompanyInfo, data)
        .then(res=>{
          if (res.data.code === myConst.code.success){
            const obj = res.data.data;
            if(obj && Object.keys(obj).length > 0){
              this.imgUrl = obj.iemsImg.infoVal;
            }
            
          }
        })
    },

    //注销登录
    logout() {
      let _this = this;
      _this
        .$confirm("确认要退出吗？", "确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        })
        .then(() => {
          _this.$axios.get(myApi.logout).then((res) => {
            //这里不要使用“/login”，不然退出登录验证码不刷新
            this.$store.commit("logoutClear"); //缓存数据清除
            this.$store.commit("integSysMenu/clearMenu"); //清除综合系统菜单相关数据
            this.$store.commit("statMenu/clearStatMent"); //清除电站菜单相关数据
            this.$store.commit("enerStorSysMenu/clearEneryMenu"); //清除储能系统菜单相关数据
            this.$store.commit("photovoltaicSysMenu/clearPhotovoMenu"); //清除光伏系统菜单相关数据
            this.$router.push({ path: "/" });
            location.reload();
          });
        })
        .catch(() => {
          return false;
        });
    },

    //一级菜单点击事件
    oneMenuClick(item) {
      this.setTopMenuSelVal(item.menuCode); //设置一级菜单的选中值
    },

    //全屏
    toggleFullScreen(){
      if (!document.fullscreenElement) {
        // 如果没有处于全屏模式，尝试进入全屏模式
        document.documentElement.requestFullscreen()
      } else {
        // 如果处于全屏模式，尝试退出全屏模式
        document.exitFullscreen()
      }
    },

    // 监听的全屏事件
    checkFullscreen() {
      this.isFullscreen = document.fullscreenElement !== null;
    },

    //监听键盘按钮事件
    handleKeydown(event) {
      if (event.key === 'F11') {
        event.preventDefault();
        this.toggleFullScreen();
      }
      if(event.key === 'F5' && !event.ctrlKey && !event.shiftKey && !event.altKey){
        if(document.fullscreenElement){
          event.preventDefault();
        }
      }
    },
  },
  created() {
    //针对复制地址栏的地址打开新的同一个页面而进行的配置
    if (!this.statId && !this.topMenuSelectVal && !this.threeMenuSelectVal) {
      if (
        !fun.isNull(this.getIntegrSysMenu) &&
        this.getIntegrSysMenu.length > 0
      ) {
        // console.log(this.getIntegrSysMenu);
        // console.log(this.getStationList);
        
        
        //直接调用初次进入页面的方法设置菜单并默认选中第一个
        this.setIntegrSysMenu(this.getIntegrSysMenu)
      }
    }
  },
  mounted() {
    this.loadSysName();
    this.loadSysImg()
     // 更改F11全屏逻辑，使全屏按键兼容
      //  window.addEventListener('keydown', this.handleKeydown)
    // 全屏监听
    document.addEventListener('fullscreenchange', this.checkFullscreen)
  },

  beforeDestroy() {
    // window.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('fullscreenchange', this.checkFullscreen);

  }
};
</script>

<style scoped>
.hd {
  display: inline-block;
  vertical-align: top;
  width: 95.3%;
  height: 5.7rem;
  background-image: url("../../assets/images/iems/top_bag_1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.one_menu_div {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 23%;
  /*background: red;*/
}

.one_menu_ul {
  float: left;
  color: #00dafc;
  padding-left: 0.2rem;
  padding-top: 0.8rem;
  width: 42.4rem;
  height: 100%;
}

.one_menu_li {
  display: inline-block;
  width: 10rem;
  height: 3.4rem;
  line-height: 3.4rem;
  background-image: url("../../assets/images/iems/one_menu_bag.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  margin-right: 0.6rem;
  font-size: 1.4rem;
  cursor: pointer;
  transition: 0.2s;
}

.one_menu_li_sel {
  background-image: url("../../assets/images/iems/one_menu_bag_sel.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fde223;
}

.one_menu_li:not(.one_menu_li_sel):hover {
  background-image: url("../../assets/images/iems/one_menu_bag_hove.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #0f98c7;
}

.one_menu_li i {
  font-size: 1.4rem;
  margin-right: 0.6rem;
}

.hd_title_div {
  position: absolute;
  top: 0;
  left: 33%;
  right: 36.5%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  /*不换行设置*/
  white-space: nowrap;
}

.hd_title_div .logo_img {
  width: 6rem;
  height: 3.5rem;
  margin-top: 0.5rem;
}

.hd_title_div div h1 {
  display: inline-block;
  vertical-align: top;
  color: white;
  font-size: 2.5rem;
  font-weight: bold;
  margin-left: 0.8rem;
  line-height: 4.5rem;
  background-image: -webkit-gradient(
    linear,
    0 39%,
    0 100%,
    from(#d8ffff),
    to(#4cc2e5)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  max-width: 75%;
}

.hd_right_div {
  position: absolute;
  top: 0;
  bottom: 0rem;
  right: 0.5rem;
  width: auto;
  text-align: right;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}

.datetime_css {
  display: inline-block;
  vertical-align: top;
}

.user_select_css {
  display: inline-block;
  vertical-align: top;
  margin-left: 1rem;
  margin-right: 1rem;
}
.logout_but {
  margin-top: 0;
  margin-left: 1.2rem;
}
.fullscreen {
  color: #00dafc;
  font-size: 1.9rem;
  font-weight: 595;
  cursor: pointer;
}
.fullscreen:hover {
  color: #0f98c7;
}
</style>
